'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCameraRetro = function FaCameraRetro(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.7 18.6q0-0.3-0.2-0.5t-0.5-0.2q-1.5 0-2.5 1t-1.1 2.5q0 0.3 0.2 0.5t0.5 0.2 0.6-0.2 0.2-0.5q0-0.9 0.6-1.5t1.5-0.6q0.3 0 0.5-0.2t0.2-0.5z m5 2.9q0 2.3-1.7 4t-4 1.7-4-1.7-1.7-4 1.7-4.1 4-1.6 4 1.6 1.7 4.1z m-22.8 12.8h34.2v-2.9h-34.2v2.9z m25.7-12.8q0-3.6-2.5-6.1t-6.1-2.5-6.1 2.5-2.5 6.1 2.5 6 6.1 2.5 6.1-2.5 2.5-6z m-22.9-14.4h8.6v-2.8h-8.6v2.8z m-2.8 4.3h34.2v-5.7h-18.4l-1.5 2.9h-14.3v2.8z m37.1-5.7v28.6q0 1.2-0.8 2t-2.1 0.8h-34.2q-1.2 0-2.1-0.8t-0.8-2v-28.6q0-1.2 0.8-2t2.1-0.8h34.2q1.2 0 2.1 0.8t0.8 2z' })
        )
    );
};

exports.default = FaCameraRetro;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/camera-retro.js
// module id = 1408
// module chunks = 0